import { render } from "./AddTrackDialog.vue?vue&type=template&id=ed060d74"
import script from "./AddTrackDialog.vue?vue&type=script&lang=js"
export * from "./AddTrackDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__